export type StatusDotTone = "open" | "success" | "warning" | "danger" | "muted" | "accent";

export interface StatusDotProps {
  tone?: StatusDotTone;
  pulse?: boolean;
  size?: number;
}

const TONE_COLORS: Record<StatusDotTone, string> = {
  open: "#0284c7",
  success: "#10b981",
  warning: "#f59e0b",
  danger: "#dc2626",
  muted: "#94a3b8",
  accent: "#4f46e5",
};

export function StatusDot({ tone = "muted", pulse = false, size = 8 }: StatusDotProps) {
  return (
    <span
      className={`inline-block shrink-0 rounded-full ${pulse ? "animate-pulse" : ""}`}
      style={{ width: size, height: size, backgroundColor: TONE_COLORS[tone] }}
    />
  );
}
